/**
 * @file
 * Patria image bank select2.
 */

(function ($, Drupal) {

  'use strict';


  Drupal.behaviors.views_image_bank = {
    attach: function (context, settings) {

      if ($('.image-bank-homepage').length) {

        $('select[id^="edit-img-category"]').select2({
          minimumResultsForSearch: -1
        });

        $('select[id^="edit-img-category"]').on('change', function() {
          $('input[id^="edit-submit-content-listings"]').trigger('click');
        });

      }

    }
  };

})(jQuery, Drupal);
